import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createBlock(_component_a_select, {
    "default-active-first-option": false,
    "filter-option": false,
    "not-found-content": null,
    placeholder: _ctx.placeholder,
    value: _ctx.value,
    "allow-clear": "",
    "show-search": "",
    onChange: _ctx.onChange,
    onClear: _ctx.onClear,
    onSearch: _ctx.onSearch
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
        return (_openBlock(), _createBlock(_component_a_select_option, {
          key: item.id,
          title: item.companyName,
          value: item.id
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(item.companyName), 1)
          ]),
          _: 2
        }, 1032, ["title", "value"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["placeholder", "value", "onChange", "onClear", "onSearch"]))
}